// extracted by mini-css-extract-plugin
export default {"upperShieldRoot":"upperShieldRoot___lABEN","kozel":"kozel___RdESO","s":"s___gdt7j","m":"m___tcYhJ","l":"l___ioF9s","upperShieldImg":"upperShieldImg___B_aOp"};